// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3HRVa","selects":"Documents_selects__f7rSq"};